var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "notification-icon-chat.03686a49.png","uri@2x": __webpack_public_path__ + "notification-icon-chat.fda7b2d5.png","uri@3x": __webpack_public_path__ + "notification-icon-chat.7a863c2a.png",
    width: 23,
    height: 22
});